import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * FormattedContent — renders Markdown with consistent AKS Legal styling.
 * Used in DocumentView for summaries, drafts, research output.
 */
const FormattedContent = ({ content, className = '' }) => (
  <div className={`formatted-content ${className}`}>
    <ReactMarkdown
      components={{
        h1: ({ children }) => <h1 className="text-xl font-bold text-slate-900 mt-4 mb-2 border-b border-slate-200 pb-1">{children}</h1>,
        h2: ({ children }) => <h2 className="text-lg font-bold text-slate-800 mt-4 mb-2">{children}</h2>,
        h3: ({ children }) => <h3 className="text-base font-semibold text-slate-800 mt-3 mb-1.5">{children}</h3>,
        h4: ({ children }) => <h4 className="text-sm font-semibold text-slate-700 mt-2 mb-1">{children}</h4>,
        p: ({ children }) => <p className="text-sm text-slate-700 leading-relaxed mb-2">{children}</p>,
        strong: ({ children }) => <strong className="font-semibold text-slate-900">{children}</strong>,
        em: ({ children }) => <em className="italic text-slate-600">{children}</em>,
        ul: ({ children }) => <ul className="list-disc pl-5 mb-2 space-y-0.5">{children}</ul>,
        ol: ({ children }) => <ol className="list-decimal pl-5 mb-2 space-y-0.5">{children}</ol>,
        li: ({ children }) => <li className="text-sm text-slate-700 leading-relaxed">{children}</li>,
        blockquote: ({ children }) => <blockquote className="border-l-3 border-[#1E3A8A] pl-3 my-2 italic bg-blue-50/50 py-1 rounded-r">{children}</blockquote>,
        hr: () => <hr className="my-3 border-slate-200" />,
        table: ({ children }) => <div className="overflow-x-auto my-2"><table className="min-w-full text-sm border border-slate-200 rounded">{children}</table></div>,
        thead: ({ children }) => <thead className="bg-slate-50">{children}</thead>,
        th: ({ children }) => <th className="px-3 py-1.5 text-left font-semibold text-slate-800 border-b border-slate-200">{children}</th>,
        td: ({ children }) => <td className="px-3 py-1.5 text-slate-700 border-b border-slate-100">{children}</td>,
      }}
    >
      {content}
    </ReactMarkdown>
  </div>
);

export default FormattedContent;
